import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import SearchBar from "@mnjsplatform/components/lib/common/SearchBar";
import textUtils from "@mnjsplatform/data/lib/utils/textUtils";
import ReportPlaceholder from "../../Common/ReportPlaceholder";
import MessageBox from "@mnjsplatform/components/lib/common/MessageBox";
import i18next from "i18next";
import {WorkplaceTypes} from "../../Common/constants";

class ConfidentialInformation extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            reportErrorMessage: ""
        };
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.listSubForPO.reset());
            await this.props.dispatch(this.props.listSubForPO.execute({}, {withParams: true}));
        } catch (e) {
            console.error(e);
        }
    }

    renderParam = (h) => {
        return (
            <>
                <div className="row mb-2">
                    <div className="col-md-4">
                        {/*Количество уровней подчиненности (<span style={{color: "red"}}>не более 10 уровней</span>):*/}
                        {h.lbl("NumSub")}
                    </div>
                    <div className="col-md-1">
                        {h.ed("NumSub")}
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-md-12">
                        {h.ed("AdmStructName")}
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-md-4">
                        {i18next.t("SubordinateSearch")}:
                    </div>
                    <div className="col-md-8" style={{height: "32px"}}>
                        <SearchBar dataItem={this.props.listSubForPO}/>
                    </div>
                </div>
            </>
        );
    };

    getTabNums = () => {
        return this.props.listSubForPO.dataTable().map(r => ({TabNum: r.TabNum}));
    };

    renderReportParams1 = (h) => {
        return (
            <div className="row">
                <div className="col-md-2">
                    {h.lbl("DateCurrentShow")}
                </div>
                <div className="col-md-2">
                    {h.ed("DateCurrentShow")}
                </div>
            </div>
        );
    };

    renderReportParams2 = (h) => {
        return (
            <div className="row">
                <div className="col-md-2">
                    {h.lbl("DateEnd")}
                </div>
                <div className="col-md-2">
                    {h.ed("DateEnd")}
                </div>
            </div>
        );
    };

    renderReportParams3 = (h) => {
        return (
            <>
                <div className="row mt-1">
                    <div className="col-md-1">
                        {h.lbl("DateEnd")}
                    </div>
                    <div className="col-md-2">
                        {h.ed("DateEnd")}
                    </div>
                </div>
                <div className="row mt-1">
                    <div className="col-md-1">
                        {h.lbl("EndDateEnd")}
                    </div>
                    <div className="col-md-2">
                        {h.ed("EndDateEnd")}
                    </div>
                </div>
            </>
        );
    };

    renderReports = () => {
        return (
            <>
                <PlaceholderWrapper placeholderId="30"
                                    title={<><i className='fa fa-table'/> {i18next.t("Reports")}</>}
                                    showSplitterLine={false}
                                    canCollapse={false}
                >
                    <ReportPlaceholder reportKey="KP_ListSrAndVac" reportId="KP_ListSrAndVac" title={i18next.t("ConfidentialInformation_FillingStaffTable")}>
                        {(reportParamsItem, build) => {
                            return (
                                <>
                                    <ComplexParam dataItem={reportParamsItem}
                                                  readOnly={false}
                                                  showSearchBar={false}
                                                  showApplyButton={false}
                                                  autoApplyParams={false}
                                                  rootPath="/"
                                                  renderParams={this.renderReportParams1}
                                    />
                                    <button className="btn mn-btn-link" onClick={async (e) => {
                                        e.preventDefault();

                                        let dateParam = reportParamsItem.getField(0, "DateCurrentShow");
                                        if (!dateParam) {
                                            this.setState({reportErrorMessage: i18next.t("ConfidentialInformation_SelectDate")});
                                            return;
                                        }

                                        await this.props.dispatch(reportParamsItem.setField(0, "TabNumSet", this.getTabNums()));

                                        await build();
                                    }}>
                                        {i18next.t("ConfidentialInformation_FillingStaffTable")}
                                    </button>
                                </>
                            );
                        }}
                    </ReportPlaceholder>
                    <hr/>
                    <ReportPlaceholder reportKey="KP_PrintPayList" reportId="KP_PrintPayList" title={i18next.t("ConfidentialInformation_SubordinatesPaySlips")}>
                        {(reportParamsItem, build) => {
                            return (
                                <>
                                    <ComplexParam dataItem={reportParamsItem}
                                                  readOnly={false}
                                                  showSearchBar={false}
                                                  showApplyButton={false}
                                                  autoApplyParams={false}
                                                  rootPath="/"
                                                  renderParams={this.renderReportParams2}
                                    />
                                    <button className="btn mn-btn-link" onClick={async (e) => {
                                        e.preventDefault();

                                        let dateParam = reportParamsItem.getField(0, "CalcPeriodId");
                                        if (!dateParam) {
                                            this.setState({reportErrorMessage: i18next.t("ConfidentialInformation_SelectBillingPeriod")});
                                            return;
                                        }

                                        await this.props.dispatch(reportParamsItem.setField(0, "TabNumSet", this.getTabNums()));

                                        await build();
                                    }}>
                                        {i18next.t("ConfidentialInformation_SubordinatesPaySlips")}
                                    </button>
                                </>
                            );
                        }}
                    </ReportPlaceholder>
                </PlaceholderWrapper>

                <PlaceholderWrapper placeholderId="40"
                                    title={<><i
                                        className='fa fa-table'/> {i18next.t("ConfidentialInformation_SubordinatesActualBonuses")}</>}
                                    showSplitterLine={false}
                                    canCollapse={false}
                >
                    <p style={{fontWeight: "bold"}}>
                        {i18next.t("ConfidentialInformation_SubordinatesActualBonuses_Instruction")}
                    </p>
                    <ReportPlaceholder reportKey="KP_PrizeFactLst" reportId="KP_PrizeFactLst" title={i18next.t("ConfidentialInformation_SubordinatesActualBonuses")}>
                        {(reportParamsItem, build) => {
                            return (
                                <>
                                    <ComplexParam dataItem={reportParamsItem}
                                                  readOnly={false}
                                                  showSearchBar={false}
                                                  showApplyButton={false}
                                                  autoApplyParams={false}
                                                  rootPath="/"
                                                  renderParams={this.renderReportParams3}
                                    />
                                    <button className="btn mn-btn-link" onClick={async (e) => {
                                        e.preventDefault();

                                        const startMonth = reportParamsItem.getField(0, "DateEnd");
                                        const endMonth = reportParamsItem.getField(0, "EndDateEnd");
                                        let message = "";
                                        if (!startMonth || !endMonth) {
                                            message = i18next.t("ConfidentialInformation_SubordinatesActualBonuses_ErrorSelectPeriod");
                                        }
                                        if (new Date(startMonth) > new Date(endMonth)) {
                                            message = i18next.t("ConfidentialInformation_SubordinatesActualBonuses_ErrorInvalidPeriod");
                                        }

                                        if (message) {
                                            this.setState({reportErrorMessage: message});
                                            return;
                                        }

                                        await build();
                                    }}>
                                        {i18next.t("ConfidentialInformation_SubordinatesActualBonuses")}
                                    </button>
                                </>
                            );
                        }}
                    </ReportPlaceholder>
                </PlaceholderWrapper>

                <MessageBox title={i18next.t("ReportBuilding")}
                            messageText={this.state.reportErrorMessage}
                            visible={!!this.state.reportErrorMessage}
                            onClose={() => {
                                this.setState({reportErrorMessage: ""})
                            }}
                />
            </>
        );
    };

    render() {
        let cnt = this.props.listSubForPO.rowsCount();
        let gridTitleText = i18next.t("SubordinateList_GridTitle", {people_count: textUtils.pluralize_i18next(cnt, "peopleCountPostfix")});

        return (
            <>
                <PlaceholderWrapper placeholderId="10"
                                    title={<><i
                                        className='fa fa-filter'/> {i18next.t("ConfidentialInformation_Title")}</>}
                                    showSplitterLine={false}
                                    canCollapse={false}
                >
                    <ComplexParam dataItem={this.props.listSubForPOParams}
                                  readOnly={false}
                                  showSearchBar={false}
                                  showApplyButton={false}
                                  autoApplyParams={true}
                                  rootPath="/"
                                  parentDataItem={this.props.listSubForPO}
                                  renderParams={this.renderParam}
                    />
                </PlaceholderWrapper>

                <PlaceholderWrapper placeholderId="20"
                                    title={<><i className='fa fa-table'/> {gridTitleText}</>}
                                    staticTitle={i18next.t("SubordinateList_GridTitle")}
                                    showSplitterLine={false}
                                    canCollapse={false}
                >
                    <GridView dataItem={this.props.listSubForPO}
                              overrideVisibility={{IsChecked: false, EstForm_ASAttrLabel: (this.props.workplaceType !== WorkplaceTypes.Slavutich)}}
                    />
                </PlaceholderWrapper>

                {this.renderReports()}
            </>
        );
    }
}

ConfidentialInformation.propTypes = {
    dispatch: PropTypes.func.isRequired,
    listSubForPO: PropTypes.object,
    listSubForPOParams: PropTypes.object,
    workplaceType: PropTypes.string
};

ConfidentialInformation.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        listSubForPO: state.confidentialInformationState.ConfidentialInformation_ListSubForPO,
        listSubForPOParams: state.confidentialInformationState.ConfidentialInformation_ListSubForPOParams,
        workplaceType: state.appState.appParams.workplaceType
    }
}

export default connect(mapStateToProps)(ConfidentialInformation);